<template>
  <Toast :close-tip="true" class="fail-get-coupon" :close-event="closeEvent">
    <p class="invite-tip">哎呀，来晚了一步好友的优惠券被领光了</br>试试领大额优惠券吧~</p>
    <div v-if="typeof other.discount != 'undefined'" class="coupon-info">
      <p class="coupon-detail">满{{other.quota}}元可用</p>
      <p class="coupon-price-box"><span>￥</span><span class="price">{{other.discount}}</span></p>
    </div>
    <p class="fail-get-coupon-btn" @click="close">我要领取</p>
  </Toast>
</template>

<script>
import Toast from "./../VueToast"
export default {
  name: 'FailGetCoupon',
  props: {
    closeEvent: Function,
    event: Function,
    other: {
      type: Object,
      default: function() { return {} }
    }
  },
  components: {
    Toast
  },
  methods: {
    close () {
      this.closeEvent();
      this.event();
    }
  }

}
</script>

<style lang="scss">
.fail-get-coupon {
  .toast__content {
    padding-top: 23px;
    position: relative;
    width: 250px;
    height: 286px;
    background-color: transparent;
    background-image: url("./../../../assets/img/get-coupon-fail-bg@2x.png");
    background: -webkit-image-set(
      url("./../../../assets/img/get-coupon-fail-bg.png") 1x,
      url("./../../../assets/img/get-coupon-fail-bg@2x.png") 2x,
      url("./../../../assets/img/get-coupon-fail-bg@3x.png") 3x
    );
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .invite-tip {
    font-size: 12px;
    color: rgba(255,255,255,0.8);
    text-align: center;
    line-height: 17px;
    text-align: center;
  }

  .coupon-info {
    margin-top: 56px;
    .coupon-detail {
      margin-bottom: 10px;
      font-size: 14px;
      color: #333333;
      text-align: center;
      line-height: 14px;
    }
    .coupon-price-box {
      display: flex;
      font-size: 20px;
      color: #FF2A18;
      align-items: baseline;
      justify-content: center;
      height: 40px;
      line-height: 40px;
      .price {
        font-family: DINAlternate-Bold;
        font-size: 40px;
      }
    }
  }
  .fail-get-coupon-btn {
    margin: 55px auto 0;
    height: 35px;
    width: 120px;
    line-height: 32px;
    color: #fff;
    background-image: linear-gradient(180deg, #FEBD38 0%, #FFA124 100%);
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>